import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFolderShared$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFolderShared extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f7b90f7a654e4c6f20a8cd2f59564ea72f972916', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e81ca0a91c54f9fca21cd030e54a9efd3b0172e1', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a2ac757edb96f8073b56b84bc72a91bb73ca72ac', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 6h7.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5V17a.5.5 0 0 1 .5-.5h4.5v-9h-7.19a.5.5 0 0 1-.44-.28L10 5.5H3.5V9a.5.5 0 0 1-.5.5h-.5A.5.5 0 0 1 2 9V4.5a.5.5 0 0 1 .5-.5h8.14a.5.5 0 0 1 .49.28zM7 20a5 5 0 1 1 0-10 5 5 0 0 1 0 10m2.83-5.3-2.15-2A.4.4 0 0 0 7 13v1.25H4.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5H7V17a.4.4 0 0 0 .68.27l2.15-2a.4.4 0 0 0 0-.57", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-folder-shared", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-folder-shared"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-folder-shared":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFolderShared$1);
            }
            break;
    } });
}

const CosmosIconFolderShared = CosmosIconFolderShared$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFolderShared, defineCustomElement };
